var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevator = function SvgElevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0556 2H6.22222C4.99492 2 4 2.99492 4 4.22222V19.7778C4 21.0051 4.99492 22 6.22222 22H12.0556M12.0556 2H17.8889C19.1162 2 20.1111 2.99492 20.1111 4.22222V6.44444M12.0556 2V22M12.0556 22H17.8889C19.1162 22 20.1111 21.0051 20.1111 19.7778V17.5556M21.7778 13.5906L20.1111 15.1467L18.4444 13.5906M21.7778 10.445L20.1111 8.88883L18.4444 10.445",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgElevator;